export var TabNames;
(function (TabNames) {
    TabNames["DELIVERY"] = "Delivery";
    TabNames["PICKUP"] = "Pick-up";
    TabNames["ADD_NEW_ADDRESS"] = "Add New Address";
    TabNames["NO_SELECTED_TAB"] = "";
    TabNames["PAYMENT_CONFIRMATION"] = "Payment Confirmation";
})(TabNames || (TabNames = {}));
export var TabValues;
(function (TabValues) {
    TabValues[TabValues["NONE"] = -1] = "NONE";
    TabValues[TabValues["DELIVERY"] = 0] = "DELIVERY";
    TabValues[TabValues["PICKUP"] = 1] = "PICKUP";
    TabValues[TabValues["ADD_NEW_ADDRESS"] = 2] = "ADD_NEW_ADDRESS";
    TabValues[TabValues["PAYMENT_CONFIRMATION"] = 3] = "PAYMENT_CONFIRMATION";
})(TabValues || (TabValues = {}));
// TODO use icon not plus sign?
export var UpdateOrderTexts;
(function (UpdateOrderTexts) {
    UpdateOrderTexts["ADD_NEW_ADDRESS_BTN"] = "+ Add New Address";
    UpdateOrderTexts["PAYMENT_WARNING"] = "Selecting this delivery method will incur a balance. To proceed with this update, please complete the payment for the outstanding balance.";
    UpdateOrderTexts["SELECT"] = "Select";
    UpdateOrderTexts["SUBMIT"] = "Submit";
    UpdateOrderTexts["UPDATE_DELIVERY"] = "Update Delivery";
    UpdateOrderTexts["UPDATE_ORDER_WARNING"] = "We understand that sometimes life can be unpredictable, and plans change. That's why we offer the flexibility to update your pickup or delivery address for your current order. However, we want to make sure you're aware that any changes you make to the address will only apply to that specific order and will not automatically update for future orders.";
    UpdateOrderTexts["LOADING_COPY"] = "Reviewing your orders, this will only take a moment...";
    UpdateOrderTexts["BACK"] = "Back";
})(UpdateOrderTexts || (UpdateOrderTexts = {}));
